import { LoginStatusResponse, ErrorResponse } from '../response';

export type LoginStatusAction = () => Promise<LoginStatusResponse | ErrorResponse>;
